/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';
import AcademyAssistantHomePageLayout from '../components/Layouts/AcademyAssistantHomePageLayout';
import HomePageLayout from '../components/Layouts/HomePageLayout';
import { useHasGate } from '../features/accounts/accountsQueries';
import UsageTracker from '../utils/UsageTracker';
import { SCREENS } from '../constants/Tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const Homepage = () => {
  const {
    hasGate: hasAiAssistantGate
  } = useHasGate('Academy:AiAssistant');
  useEffect(() => {
    UsageTracker.trackStandalone('Pageview', {
      screen: SCREENS.HOME
    });
  }, []);
  if (hasAiAssistantGate === true) {
    return /*#__PURE__*/_jsx(AcademyAssistantHomePageLayout, {});
  }
  return /*#__PURE__*/_jsx(HomePageLayout, {});
};
export default Homepage;